exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart-button .affirm-as-low-as,\n.cart-button .__affirm-logo-black {\n  color: #444259;\n}\n.cart-button .affirm-as-low-as {\n  font-weight: bold;\n}\n.cart-button .__affirm-logo-black {\n  font-size: 20px;\n  margin-left: 5px;\n}\n.cart-button .affirm-modal-trigger {\n  display: block;\n  font-weight: normal;\n  color: #8d29a0;\n}\n.cart-button .affirm.pointer:hover .affirm-modal-trigger {\n  text-decoration: underline;\n}", ""]);

// exports
